import {
  CompoundButton,
  FontIcon,
  FontSizes,
  Heading,
  IIconProps,
  Image,
  mergeStyleSets,
  Stack,
  useTheme
} from "@bps/fluent-ui";

import { PageLinkBaseProps } from "./PageLink.types.ts";

export const PageLinkBase: React.FC<PageLinkBaseProps> = ({
  iconName,
  headingLevel,
  headingText,
  styles,
  disabled,
  onClick,
  getImage,
  children
}) => {
  const theme = useTheme();

  const chevronIconStyles: Partial<IIconProps> = {
    iconName: "ChevronRight",
    styles: { root: { color: theme.palette.themePrimary } }
  };

  return (
    <CompoundButton
      disabled={disabled}
      styles={mergeStyleSets(styles, {
        flexContainer: {
          flexDirection: "row-reverse",
          justifyContent: "space-between",
          alignItems: "center"
        },
        icon: {
          fontSize: FontSizes.size16
        },
        rootHovered: {
          color: theme.palette.neutralPrimary
        },
        rootPressed: {
          color: theme.palette.neutralPrimary
        },
        root: {
          borderRadius: 4,
          padding: "16px 24px",
          maxWidth: "none",
          selector: {
            ".ms-Fabric--isFocusVisible &:focus::after": {
              outline: "none"
            },
            ".ms-Fabric--isFocusVisible &:focus": {
              outline: "none",
              borderRadius: 4,
              boxShadow: `0 0 0 1px ${theme.palette.neutralDark}`
            }
          }
        }
      })}
      iconProps={chevronIconStyles}
      onClick={onClick}
    >
      <Stack
        grow
        tokens={{ childrenGap: 4 }}
        horizontal
        horizontalAlign="space-between"
      >
        <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 8 }}>
          {iconName && (
            <FontIcon
              iconName={iconName}
              styles={{
                root: {
                  color: theme.palette.themePrimary,
                  fontSize: FontSizes.size24
                }
              }}
            />
          )}
          {getImage && <Image width="154.54" height="27" src={getImage} />}
          <Heading variant={headingLevel}>{headingText}</Heading>
        </Stack>
        {children}
      </Stack>
    </CompoundButton>
  );
};
